const ITEMS = [
  "Local Technician",
  "Upfront Price",
  "No Surprise Night/Weekend Fees",
  "24/7 Mobile Assistance",
  "Minneapolis, MN",
];

const Row = () => (
  <div className="flex items-center gap-8 pr-8 shrink-0">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center gap-8 shrink-0">
        <span className="font-display font-semibold uppercase tracking-wide text-2xl md:text-4xl text-neutral-200 whitespace-nowrap">
          {item}
        </span>
        <span className="w-2.5 h-2.5 bg-primary shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee" className="relative border-y border-white/10 py-5 overflow-hidden bg-[#050505]">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
